import { render } from "./Debugger.vue?vue&type=template&id=51f7485c&scoped=true&bindings={\"validator\":\"props\",\"model\":\"props\",\"touch\":\"options\"}"
import script from "./Debugger.vue?vue&type=script&lang=js"
export * from "./Debugger.vue?vue&type=script&lang=js"

import "./Debugger.vue?vue&type=style&index=0&id=51f7485c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51f7485c"

export default script